import { Mail } from "lucide-react";

const fmtDate = (iso) => new Date(`${iso}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export const trialDaysLeft = (iso) => {
  if (!iso) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((new Date(`${iso}T00:00:00`).getTime() - today.getTime()) / 86400000);
};

// Login-screen banner: floats centered at the top edge of the card. Green while > 5 days
// remain, red/bold at 5 days or less.
export function TrialEndLine({ health }) {
  if (!health || health.license_status !== "trial" || !health.trial_end_date) return null;
  const days = trialDaysLeft(health.trial_end_date);
  const urgent = days <= 5;
  return (
    <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10 w-full flex justify-center px-6">
      <p
        className={
          urgent
            ? "bg-red-600 text-white font-bold text-[13px] leading-tight px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap"
            : "bg-green-600 text-white font-semibold text-[13px] leading-tight px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap"
        }
        data-testid="login-trial-end"
        data-urgent={urgent ? "1" : "0"}
      >
        Trial ends {fmtDate(health.trial_end_date)}{days >= 0 ? ` · ${days === 0 ? "last day" : `${days} day${days === 1 ? "" : "s"} left`}` : ""}
      </p>
    </div>
  );
}

// Replaces the login form once the Trial Date End has passed.
export function TrialExpiredNotice({ health }) {
  const end = health?.trial_end_date;
  return (
    <div className="rounded-2xl border border-red-200 bg-red-50 px-6 py-7 text-center space-y-3" data-testid="login-trial-expired">
      <p className="text-red-700 font-bold text-xl leading-tight">Your ModeskPOS trial has ended</p>
      {end && <p className="text-zinc-600 text-sm">Trial period ended on <b>{fmtDate(end)}</b>.</p>}
      <p className="text-zinc-700 text-sm">
        Thank you for trying ModeskPOS. To keep your store running, please contact <b>ModeskPOS Support</b> and we will activate your license right away.
      </p>
      <a href="mailto:support@modeskpos.com" className="inline-flex items-center gap-2 text-blue-700 font-bold text-base hover:underline" data-testid="login-trial-support-email">
        <Mail className="w-4 h-4" /> support@modeskpos.com
      </a>
    </div>
  );
}
